var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImmigrationLaw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256.42 380.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{stroke-width:9px;}.cls-2,.cls-3{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;}.cls-3{stroke-width:13px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M235.81,9c6.41,0,11.6,5.2,11.6,11.6V359.88c0,6.41-5.2,11.6-11.6,11.6H20.6c-6.41,0-11.6-5.2-11.6-11.6V20.6c0-6.41,5.2-11.6,11.6-11.6H235.81m0-9H20.6C9.24,0,0,9.24,0,20.6V359.88c0,11.36,9.24,20.6,20.6,20.6H235.81c11.36,0,20.6-9.24,20.6-20.6V20.6c0-11.36-9.24-20.6-20.6-20.6h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 128.21,
    cy: 179.6,
    r: 74.35
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M128.26,253.94s-.04-.02-.05-.03c-27.71-13.25-46.86-41.55-46.86-74.32s19.14-61.07,46.86-74.32c.02-.01,.04-.02,.05-.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M128.16,253.94s.04-.02,.05-.03c27.71-13.25,46.85-41.55,46.85-74.32s-19.14-61.07-46.85-74.32c-.02-.01-.04-.02-.05-.03"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M183.19,129.55c-5.25,4.71-11.1,8.76-17.43,12-11.26,5.78-24.02,9.04-37.55,9.04s-26.3-3.26-37.56-9.04c-6.33-3.25-12.18-7.3-17.43-12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.22,229.64c5.24-4.7,11.09-8.75,17.43-12,11.26-5.78,24.03-9.04,37.56-9.04s26.29,3.26,37.55,9.04c6.33,3.25,12.18,7.29,17.43,12"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "128.21 253.94 128.21 253.92 128.21 208.6 128.21 179.6 128.21 150.59 128.21 105.27 128.21 105.25"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "53.86 179.6 81.35 179.6 128.21 179.6 175.06 179.6 202.56 179.6"
  }))), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 63.69,
    y1: 307.69,
    x2: 192.73,
    y2: 307.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 81.36,
    y1: 335.54,
    x2: 175.06,
    y2: 335.54
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImmigrationLaw);
export default __webpack_public_path__ + "static/media/immigrationLaw.b14ce6c1c9ea29c29e2b92f0863756ab.svg";
export { ForwardRef as ReactComponent };